import React from 'react';
import { useReveal } from '../lib/useReveal';
export function GuaranteeSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#3d2a5f] py-12 md:py-16 px-5 sm:px-6 border-t border-[#4d3a6f] relative overflow-hidden" data-id="element-201">
      <div className="container mx-auto max-w-3xl relative z-10" data-id="element-202">
        <div ref={ref1} className={`reveal bg-[#4d3a6f] rounded-3xl p-8 md:p-12 border border-[#c9a14d]/20 shadow-[0_20px_50px_rgba(0,0,0,0.2)] text-center ${vis1 ? 'is-visible' : ''}`} data-id="element-203">
          <div className="w-20 h-20 bg-gradient-to-br from-[#c9a14d] to-[#b8945a] rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg" data-id="element-204">
            <span className="text-4xl" data-id="element-205">🛡️</span>
          </div>

          <h2 className="text-2xl md:text-4xl font-bold text-white mb-6" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-206">
            GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>

          <div className="space-y-4 text-white/80 text-base md:text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-207">
            <p data-id="element-208">Abrís los tomos. Los usás en tu práctica.</p>
            <p data-id="element-209">
              Si en 7 días no es lo que esperabas — devolución del 100%. Sin
              formularios. Sin drama.
            </p>
            <p className="text-[#c9a14d] font-bold text-sm uppercase tracking-widest mt-6" data-id="element-210">
              Tasa de devoluciones: menos del 1%.
            </p>
          </div>
        </div>
      </div>
    </section>;
}